<template>
  <template v-if="isLoading">
    <loading :isLoading="isLoading" :message="'処理中...'"></loading>
  </template>
  <template v-if="!isLoading && !isUpdated">
    <div class="form-item">
      <label>今年度付与日数</label>
      <div class="before-after">
        <p class="before">{{ syuuseiData.before.fuyoDays ? syuuseiData.before.fuyoDays : '' }}</p>
        <p class="arrow">→</p>
        <input-text type="number" class="after" v-model="syuuseiData.after.fuyoDays" :error="getError(inputCheckFuyoDays, 'fuyo_days')"></input-text>
      </div>
      <label>特別有給</label>
      <div class="before-after">
        <p class="before">{{ syuuseiData.before.tokubetsuKyuukaDays ? syuuseiData.before.tokubetsuKyuukaDays : '' }}</p>
        <p class="arrow">→</p>
        <input-text type="number" class="after" v-model="syuuseiData.after.tokubetsuKyuukaDays" :error="getError(inputCheckFuyoDays, 'tokubetsu_kyuuka')"></input-text>
      </div>
    </div>
    <div class="buttons">
      <button type="button" class="btn success" @click="send()"><i class="fa-solid fa-check"></i>更新</button>
      <button type="button" class="btn cancel" @click="cancel()"><i class="fa-solid fa-x"></i>閉じる</button>
    </div>
  </template>
  <template v-if="!isLoading && isUpdated">
    <div class="form-item updated">
      <label>更新しました</label>
    </div>
    <div class="buttons">
      <button type="button" class="btn cancel" @click="close()"><i class="fa-solid fa-x"></i>閉じる</button>
    </div>
  </template>
</template>

<script lang="ts">
import { useFuyo } from '@/composable/yuukyuu/detail/fuyo';
import { FuyoSyuuseiData } from '@/composable/modal/fuyo-syuusei';
import { computed, defineComponent, ref } from 'vue';
import { useForm } from "@/composable/form/form";

export default defineComponent({
  props: {
    syuuseiData: {
      type: Object as () => FuyoSyuuseiData,
      default: null
    },
    userId: {
      type: Number,
      require: true
    }
  },
  emits: {
    cancel: () => true,
    close: () => true,
  },
  setup(props, context) {
    const { fuyoUpdate, isLoading } = useFuyo()
    const isUpdated = ref(false)
    const { getError } = useForm();
    const inputCheckFuyoDays = ref({});

    const send = async () => {
      // console.log(props.syuuseiData);

      isUpdated.value = false
      if (!props.syuuseiData.after.fuyoDays || !props.userId || !props.syuuseiData.after.this_year_fuyo_date) {
        inputCheckFuyoDays.value = {'errors':{'fuyo_days':['値は0.5単位で入力して下さい']}};
        return
      }
      if (!props.syuuseiData.after.tokubetsuKyuukaDays || !props.userId || !props.syuuseiData.after.this_year_fuyo_date) {
        inputCheckFuyoDays.value = {'errors':{'tokubetsu_kyuuka':['値は1単位で入力して下さい']}};
        return
      }

      // 入力チェック 0以上かどうか
      if(parseInt(props.syuuseiData.after.fuyoDays, 10) < 0){
        inputCheckFuyoDays.value = {'errors':{'fuyo_days':['値は0以上を入力して下さい']}};
        return;
      }
      if(parseInt(props.syuuseiData.after.tokubetsuKyuukaDays, 10) < 0){
        inputCheckFuyoDays.value = {'errors':{'tokubetsu_kyuuka':['値は0以上を入力して下さい']}};
        return;
      }

      try {
        let resultRes = await fuyoUpdate(props.userId, Number(props.syuuseiData.after.fuyoDays), Number(props.syuuseiData.after.tokubetsuKyuukaDays), props.syuuseiData.after.this_year_fuyo_date);

        // 登録エラーの場合
        if(!resultRes.result){
          // エラーメッセージを設定
          inputCheckFuyoDays.value= resultRes.error;
          return;
        }

        isUpdated.value = true
      } catch (e) {
        console.error(e);
      }
    }

    const cancel = () => {
      context.emit('cancel');
    }

    const close = () => {
      context.emit('close');
    }

    const syuuseiData = computed(() => {
      return props.syuuseiData
    })

    return {
      send,
      cancel,
      close,
      syuuseiData,
      isLoading,
      isUpdated,
      getError,
      inputCheckFuyoDays,
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/dialog/fuyo-syuusei.scss';
</style>
